import {Http, Response} from '@angular/http';
import {TranslateLoader} from '@ngx-translate/core';
import 'rxjs/add/operator/map';
import { Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

export class TranslateHttpLoader implements TranslateLoader {

  private http: any;

  constructor(
    private injector: Injector,
    private prefix: string = `${environment.staticPath}/assets/i18n/`,
    private suffix: string = '.json'
  ) {}

  /**
   * Gets the translations from the server
   * @param lang
   * @returns {any}
   */
  public getTranslation(lang: string): any {
    return Observable.create(obsr => {
      // Fix cyclic dependancies =C
      setTimeout(() => {
        this.http = this.injector.get(Http);
        this.http.get(`${this.prefix}${lang}${this.suffix}`)
          .map((res: Response) => res.json())
          .subscribe(res => {
            obsr.next(res);
            obsr.complete();
          });
      });
    });
  }
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/translates/loader.service.ts